module.exports = __webpack_public_path__ + "static/media/hourglass_rainbow_fullaf9b364b50f8d33d2f72a440f4107734.webp";